import { render, staticRenderFns } from "./SDOrders.vue?vue&type=template&id=71379ffc&scoped=true&"
import script from "./SDOrders.vue?vue&type=script&lang=js&"
export * from "./SDOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71379ffc",
  null
  
)

export default component.exports